import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import mainContext from "../context/mainContext";
import { addBoxApi } from "../services/leitnerApi";
import { checkErrorMessage, checkResponseData } from "../utils/utilsFunctions";

export default function CreateBox() {
  const { boxesList, handleEditBoxlist } = useContext(mainContext);
  const nav = useNavigate();
  const [name, setName] = React.useState("");
  const [fromLang, setFromLang] = React.useState("en");
  const [toLang, setToLang] = React.useState("fa");
  const [description, setDescription] = React.useState("");
  const [inProgress, setInProgress] = React.useState(false);

  const languages = {
    en: "انگلیسی", de: "المانی", fr: "فرانسوی",
    fa: "فارسی", tr: "ترکی", it: "ایتالیایی",
  };

  const submit = async (e) => {
    setInProgress(true);
    e.preventDefault();
    try {
      const response = await addBoxApi({ name, fromLang, toLang, description });
      const res = checkResponseData(response);
      if (res["success"]) {
        const newBoxList = [...boxesList];
        newBoxList.push(res["data"]["data"][0]);
        handleEditBoxlist(newBoxList);
        toast.success("باکس ساخته شد");
        nav("/home");
      } else {
        toast.error(res["message"] || "مشکلی در ذخیره اطلاعات وجود دارد");
      }
      setInProgress(false);
    } catch (error) {
      setInProgress(false);
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.error(errMsg || "مشکلی در ذخیره اطلاعات وجود دارد");
    }
  };

  return (
    <div className="container" style={{ maxWidth: 560 }}>
      {inProgress ? (
        <div className="center" style={{ marginTop: 64, flexDirection: "column", gap: 12 }}>
          <div className="spinner"></div>
          <p style={{ color: "var(--text-secondary)" }}>در حال ساخت {name}...</p>
        </div>
      ) : (
        <div className="card">
          <h2 style={{ margin: "0 0 20px", fontSize: 20 }}>ساخت جعبه لایتنر جدید</h2>
          <form onSubmit={submit}>
            <label className="label">نام باکس</label>
            <input
              className="input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="مثال: لغات انگلیسی روزمره"
              required
            />
            <div className="row" style={{ marginTop: 16 }}>
              <div style={{ flex: 1 }}>
                <label className="label">زبان اول (لغات)</label>
                <select className="input" value={fromLang} onChange={(e) => setFromLang(e.target.value)}>
                  {Object.entries(languages).map(([key, label]) => (
                    <option key={key} value={key}>{label}</option>
                  ))}
                </select>
              </div>
              <div style={{ flex: 1 }}>
                <label className="label">زبان دوم (ترجمه)</label>
                <select className="input" value={toLang} onChange={(e) => setToLang(e.target.value)}>
                  {Object.entries(languages).map(([key, label]) => (
                    <option key={key} value={key}>{label}</option>
                  ))}
                </select>
              </div>
            </div>
            <label className="label" style={{ marginTop: 16 }}>
              توضیحات (اختیاری)
            </label>
            <textarea
              className="textarea"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="توضیح کوتاهی درباره این جعبه لایتنر..."
            />
            <div className="row" style={{ marginTop: 20, justifyContent: "flex-end" }}>
              <button className="btn ghost" type="button" onClick={() => nav(-1)}>
                انصراف
              </button>
              <button className="btn" type="submit">
                ساخت لایتنر
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
